import { useRef } from 'react';

import { useScoreZoom } from '../../hooks/useScoreZoom';

/**
 * Zoom surface for the white score column. Pinch or ctrl/cmd + wheel
 * here magnifies this column; toolbar, guest banner, and side/bottom
 * toggles sit outside so those gestures still page-zoom the UI.
 *
 * Layout classes on `className` (max-width, background) are the
 * resting clip. Zoom grows that clip toward 90vw, then scales
 * inside it. `footer` (the CTA card) sits outside that scale;
 * `sticky left-0` keeps it aligned while the score pans sideways.
 */
export const ScoreViewport: React.FC<{
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
}> = ({ children, className = '', footer }) => {
  const viewportRef = useRef<HTMLDivElement>(null);
  const sizerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useScoreZoom({ viewportRef, sizerRef, contentRef });

  return (
    <div
      ref={viewportRef}
      className={`score-zoom-viewport min-w-0 overflow-x-auto overflow-y-clip ${className}
      `}
    >
      <div ref={sizerRef} className="relative w-full">
        <div
          ref={contentRef}
          className="flex w-full origin-top-left flex-col items-center gap-y-6"
        >
          {children}
        </div>
      </div>
      {footer ? (
        <div className="sticky left-0 flex w-full justify-center pt-6">
          {footer}
        </div>
      ) : null}
    </div>
  );
};
